import { call, fork, put, select, takeLatest } from 'redux-saga/effects';
import i18n from '@/../i18n';
import { OnboardingActionTypes, SaveOnboardingStartAction } from '@/store/onboarding/types';
import {
    LoadOnboardingError,
    LoadOnboardingSuccess,
    SaveOnboardingSuccess,
    SaveOnboardingError,
    getOnboardingStore,
} from '@/store/onboarding/actions';
import { saveOnboardingData, loadOnboardingData, finishOnboarding as finishOnboardingApi } from '@/services/ElasticApi';
import { errorToast } from './commonGenerators/errorToast';

function* saveOnboarding({ payload }: SaveOnboardingStartAction): any {
    try {
        const { savedData, isAlreadySaved } = yield select(getOnboardingStore);
        yield call(saveOnboardingData, JSON.stringify({ ...savedData, ...payload }), isAlreadySaved);
        yield put(SaveOnboardingSuccess());
    } catch (e) {
        yield put(SaveOnboardingError());
        yield call(errorToast, e);
    }
}

function* loadOnboarding(): any {
    try {
        const response = yield call(loadOnboardingData);
        if (response.status !== 200) {
            throw new Error(i18n.t('apitimeout'));
        }
        yield put(LoadOnboardingSuccess(response.data));
    } catch (e) {
        yield put(LoadOnboardingError());
        yield call(errorToast, e);
    }
}

function* finishOnboarding(): any {
    try {
        const response = yield call(finishOnboardingApi);
        if (response.status !== 200) {
            throw new Error(i18n.t('apitimeout'));
        }
    } catch (e) {
        yield call(errorToast, e);
    }
}

function* saveOnboardingWatcher(): any {
    yield takeLatest(OnboardingActionTypes.SAVE_ONBOARDING_START, saveOnboarding);
}

function* loadOnboardingWatcher(): any {
    yield takeLatest(OnboardingActionTypes.LOAD_ONBOARDING_START, loadOnboarding);
}

function* finishOnboardingWatcher(): any {
    yield takeLatest(OnboardingActionTypes.FINISH_ONBOARDING, finishOnboarding);
}

const onboardingSagas = [fork(saveOnboardingWatcher), fork(loadOnboardingWatcher), fork(finishOnboardingWatcher)];

export default onboardingSagas;
